import React, { useEffect, useState } from "react";
import { Flex, Select, Space, Tag, Form, Spin } from "antd";
import Title from "antd/es/typography/Title";
import TabSelectSupplier from "./tab-select-supplier.user";
import { IOwnerResult, ISupplierResult, IUserResult } from "../../interfaces/user";
import { UserServices } from "../../services/user";

interface EditTransferSupplierProps {
  detailUser: IUserResult | undefined;
  onLoadingChange?: (loading: boolean) => void;
}

const EditTransferSupplier: React.FC<EditTransferSupplierProps> = ({ detailUser, onLoadingChange }) => {
  const [suppliers, setSuppliers] = useState<ISupplierResult>();
  const [owners, setOwners] = useState<IOwnerResult[]>([]);
  const [ownerSelect, setOwnerSelect] = useState<IOwnerResult>();
  const [loading, setLoading] = useState(false);

  const setBothLoading = (v: boolean) => {
    setLoading(v);
    onLoadingChange?.(v);
  };

  useEffect(() => {
    const fetchAllData = async () => {
      if (detailUser) {
        try {
          setBothLoading(true);
          const [ownersRes, suppliersRes] = await Promise.all([
            UserServices.getListOwner(detailUser.id),
            UserServices.getListSupplierByUser(detailUser.id),
          ]);

          if (ownersRes.success) {
            setOwners(ownersRes.data);
          }

          if (suppliersRes.success) {
            setSuppliers(suppliersRes.data);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setBothLoading(false);
        }
      }
    };
    fetchAllData();
  }, [detailUser]);

  const handleChange = (value: number) => {
    setOwnerSelect(owners.find((item) => item.id === value));
  };

  const showChipByUser = (owner: IOwnerResult | null | undefined) => {
    const listChipShow = [];
    if (owner) {
      if (owner?.productHead) {
        listChipShow.push(
          <Tag key={1} color="blue">
            Product Head
          </Tag>
        );
      }
      if (owner?.productOwner) {
        listChipShow.push(
          <Tag key={2} color="blue">
            Product Owner
          </Tag>
        );
      }
      if (owner?.apOwner) {
        listChipShow.push(
          <Tag key={3} color="blue">
            AP Owner
          </Tag>
        );
      }
      if (owner?.apEscalation) {
        listChipShow.push(
          <Tag key={4} color="blue">
            AP Escalator
          </Tag>
        );
      }
    }
    return listChipShow;
  };

  if (loading) {
    return (
      <Flex vertical justify="center">
        <Spin size="large" />
      </Flex>
    );
  }

  return (
    <Space direction="vertical" size="middle" style={{ display: "flex" }}>
      <Flex gap="small" vertical style={{ height: 400 }}>
        <Title level={5} style={{ marginTop: 0 }}>
          1. Select Suppliers to Transfer
        </Title>
        <TabSelectSupplier
          detailUser={detailUser}
          apOwner={suppliers?.apOwner ?? []}
          apEscalation={suppliers?.apEscalation ?? []}
          productHead={suppliers?.productHead ?? []}
          productOwner={suppliers?.productOwner ?? []}
          fieldName="role"
        />
      </Flex>
      <Flex vertical>
        <Title level={5} style={{ marginTop: "0" }}>
          2. Select New Owner
        </Title>
        <Form.Item name="idNewOwner" rules={[{ required: true, message: "Please select a new owner" }]}>
          <Select
            showSearch
            allowClear
            placeholder="Select a person"
            optionFilterProp="label"
            onChange={handleChange}
            options={owners.map((item: IOwnerResult) => ({
              label: `${item.firstName} ${item.lastName}`,
              value: item.id,
            }))}
          />
        </Form.Item>
        <Flex gap="small">{showChipByUser(ownerSelect)}</Flex>
      </Flex>
    </Space>
  );
};

export default EditTransferSupplier;
